import { apiService } from './api.service';
import { PaginatedResponse } from 'types/index';
import { User } from 'types/user';
import api_no_token_Service from './api_no_token.service';

class UsersService {
  async list(page: number = 1, limit: number = 100): Promise<PaginatedResponse<User>> {
    const response = await apiService.get<PaginatedResponse<User>>(`/user/GetPageList?page=${page}&pageSize=${limit}`);

    if ((response as any)?.data && (response as any)?.success !== false && (response as any).data?.data && (response as any).data?.pagination) {
      return (response as any).data as PaginatedResponse<User>;
    }

    const maybeItems = (response as any)?.items;
    const maybeTotal = (response as any)?.totalCount;
    if (Array.isArray(maybeItems) && typeof maybeTotal === 'number') {
      const totalPages = Math.max(1, Math.ceil(maybeTotal / limit));
      return {
        data: maybeItems as User[],
        pagination: { page, limit, total: maybeTotal, totalPages },
      };
    }

    const data = (response as any)?.data || response;
    if (Array.isArray(data)) {
      return {
        data: data as User[],
        pagination: { page, limit, total: data.length, totalPages: 1 },
      };
    }

    throw new Error((response as any)?.message || 'Failed to load users');
  }

  async getById(id: string): Promise<User> {
    const response = await apiService.get<any>(`/user/${id}`);
    const payload: any = (response as any)?.data ?? response;
    const userData = payload?.data && typeof payload.data === 'object' ? payload.data : typeof payload === 'object' ? payload : null;
    if (userData) return userData as User;
    return response as unknown as User;
  }

  async getRegisterData(id: string): Promise<{ user: User; company: any | null }> {
    const response = await api_no_token_Service.get<any>(`/user/GetRegisterData/${id}`);
    const payload: any = (response as any)?.data ?? response;
    
    if (payload?.success && payload?.user) {
      return {
        user: payload.user as User,
        company: payload.company || null
      };
    }
    
    throw new Error(payload?.error || 'Failed to load register data');
  }

  async create(payload: Partial<User>): Promise<User> {
    const response = await apiService.post<User>(`/user`, payload);
    if ((response as any)?.data && (response as any)?.success !== false) {
      return (response as any).data as User;
    }
    return (response as any) as User;
  }

  async createUser(payload: Partial<User>): Promise<User> {
    const response = await apiService.post<User>(`/user/CreateCompanyUser`, payload);
    if ((response as any)?.data && (response as any)?.success !== false) {
      return (response as any).data as User;
    }
    return (response as any) as User;
  }

  async update(id: string, payload: Partial<User>): Promise<User> {
    const response = await apiService.put<User>(`/user/${id}`, payload);
    if ((response as any)?.data && (response as any)?.success !== false) {
      return (response as any).data as User;
    }
    return (response as any) as User;
  }

  async remove(id: string): Promise<void> {
    const response = await apiService.delete(`/user/${id}`);
    if ((response as any)?.success === false) {
      throw new Error((response as any)?.message || 'Delete failed');
    }
  }
}

export const usersService = new UsersService();
export default usersService;


